import { useState } from 'react';

interface Props {
	validations?: (value: string) => string | boolean | undefined;
	defaultValue?: string;
	options?: any;
}

const useAutocompleteInput: any = ({
	validations,
	defaultValue,
	options,
}: Props = {}) => {
	const [value, setValue] = useState(defaultValue || '');
	const [tag, setTag] = useState('');
	const [errorMessage, setErrorMessage] = useState<any>(null);

	const handleValidation = (val?: any) => {
		if (validations) {
			const inputErrorMessage = validations(val);
			if (inputErrorMessage) {
				setErrorMessage(inputErrorMessage);
			} else {
				setErrorMessage(null);
			}
		}
	};

	const handleInputOnChange = (event: any) => {
		const inputValue = (event.target as HTMLInputElement).value;
		if (inputValue.length > 1) {
			const exactTag = options.find((option: any) =>
				option.includes(inputValue),
			);
			if (exactTag) {
				setTag(exactTag);
			}
		} else {
			setTag('');
		}
		setValue(inputValue);
		handleValidation(inputValue);
	};

	return {
		value,
		setValue,
		errorMessage,
		tag,
		reset: () => setValue(''),
		bind: {
			value,
			tag,
			errorMessage,
			onChange: handleInputOnChange,
			setValue,
			fireValidationOnBlur: () => {
				handleValidation(value);
			},
			onBlur: () => {
				setTimeout(() => {
					setTag('');
				}, 100);
			},
		},
	};
};

export default useAutocompleteInput;
